module.exports = __webpack_public_path__ + "static/media/MCI.e0950dc2.png";